/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon24Regular = forwardRef('ArrowDUturnUpRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.848.762a.875.875 0 1 0-1.196 1.276l4.359 4.087H11a7.875 7.875 0 0 0 0 15.75h6a.875.875 0 1 0 0-1.75h-6a6.125 6.125 0 0 1 0-12.25h7.064l-4.412 4.137a.875.875 0 1 0 1.196 1.276l4.833-4.53c1.001-.939 1.001-2.527 0-3.466L14.848.762Z" })));
});
